import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SampleService } from 'src/app/services/sample.service';
import { catchError, ReplaySubject, Subject, takeUntil, throwError } from 'rxjs';
import { AddNewGroupComponent } from '../../add-new-group/add-new-group.component';
import { GroupService } from 'src/app/services/group.service';
import { SampleGroupModel } from 'src/app/models/sample-group-model';
import { PlantPart } from 'src/app/models/plant-part';
import {GrowthStageModel} from "../../../models/growth-stage";
import { PinDetailsService } from 'src/app/pin-reworks/pin-services/pin-details.service';

@Component({
    selector: 'app-add-edit-soft-tissue-sample',
    templateUrl: './add-edit-soft-tissue-sample.component.html',
    styleUrls: ['./add-edit-soft-tissue-sample.component.css'],
    standalone: false
})
export class AddEditSoftTissueSampleComponent {

  softTissueSampleForm: FormGroup;
  groups = [];
  group: SampleGroupModel = null;
  plantPartsList = [];
  plantPart: PlantPart;
  growthStages: GrowthStageModel[] = []
  pinId: number = this.data.pinId;
  userId: number = this.data.userId;
  sampleId: number = this.data.sampleId;

  filteredGrowthStage: GrowthStageModel[] = [];

  isEditSampleMode:boolean = false;
  isAddNewSapleMode:boolean = false;
  isCompleted: boolean = false;
  definitions: any[] = [];
  selectedDefinitionId: number = null;
  isOrphanedLink: boolean = false;

      /** control for the selected group */
      // public groupCtrl: FormControl<SampleGroupModel> = new FormControl<SampleGroupModel>(null);

      /** control for the MatSelect filter keyword */
      public groupFilterCtrl: FormControl<string> = new FormControl<string>('');

    /** list of group filtered by search keyword */
    public filteredSampleGroups: ReplaySubject<SampleGroupModel[]> = new ReplaySubject<SampleGroupModel[]>(1);

      /** Subject that emits when the component has been destroyed. */
      protected _onGroupDestroy = new Subject<void>();


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      private newSampleFb: FormBuilder,
      public softTissueSampleDialog: MatDialogRef<AddEditSoftTissueSampleComponent>,
      public addGroupDialog: MatDialog,
      private sampleService: SampleService,
      private groupService: GroupService,
      public nav: NavBarComponent,
      private pinDetailsService: PinDetailsService
  ) {
    this.softTissueSampleForm = this.newSampleFb.group({
      sampleName: ['',Validators.required],
      // cropAge: new FormControl(null),
      growthStage: new FormControl(null),
      plantPart: new FormControl(null),
      note: new FormControl(''),
      pinSampleGroup: [null,Validators.required],
    });
  }
  ngOnInit(): void {
    this.nav.toggleLoading(true);
    this.populatePlantPartList();
    this.populateGroupDropdown();
    this.setPreviousSelection()
    this.loadDefinitions();
    
    if(this.data !== null){
      this.isEditSampleMode = this.data.isEditSampleMode;
      this.isAddNewSapleMode = this.data.isAddNewSapleMode;
    }

    this.growthStages = this.data.growthStages;
    this.filteredGrowthStage = this.growthStages;

    if(this.data && this.isEditSampleMode){

      setTimeout(()=>{
        this.isCompleted = this.data?.isCompleted;
        this.softTissueSampleForm.controls.sampleName.setValue(this.data.sampleName);
        this.softTissueSampleForm.controls.growthStage.setValue(this.data.pinCropGrowthStageLinkId);

        if(this.data?.plantPart){
          for(let plantPart of this.plantPartsList){
            if(plantPart?.id === this.data?.plantPart){
              this.plantPart = plantPart;
              break;
            }
          }
          this.softTissueSampleForm.controls.plantPart.setValue(this.plantPart);
        }

        this.softTissueSampleForm.controls.note.setValue(this.data.note);

        if(this.data?.linkedGroup){

          for(let group of this.groups){
            if(group?.id === this.data?.linkedGroup || group.id === this.data?.linkedGroup?.id){
              this.group = group;
              break;
            }
          }
        }
        this.softTissueSampleForm.controls.pinSampleGroup.setValue(this.group);
        this.nav.toggleLoading(false);
      },1000)
    }
  }

       /**
   * Method that sets the intial group list that will be displayed in the group dropdown.
   */
       setInitialGroupList() {
        // Load the initial group list
        this.filteredSampleGroups.next(this.groups.slice());
        // Listen for search field value changes
        this.groupFilterCtrl.valueChanges
          .pipe(takeUntil(this._onGroupDestroy))
          .subscribe(() => {
            this.filterGroups();
          });
      }

  protected filterGroups() {
    if (!this.groups) {
      return;
    }
    // Get the search keyword
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredSampleGroups.next(this.groups.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter the group based on the search keyword
    this.filteredSampleGroups.next(
      this.groups.filter(group => group.name.toLowerCase().indexOf(search) > -1)
    );
  }

  populatePlantPartList(){
    this.sampleService.getSoftTissuePlantPartList().pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((response) =>{
      this.plantPartsList = response;
    })
   
  }

  onGrowthStageSearch(searchString: string) {
    this.filteredGrowthStage = this.growthStages.filter(
        item => item.name.toLowerCase().includes(searchString.toLowerCase())
    );
  }

  setSelectedPlantPart(plantPart: PlantPart){

    this.plantPart = plantPart;
    this.softTissueSampleForm.controls.plantPart.setValue(plantPart);
  }

    addNewGroup(){
      const dialogRef = this.addGroupDialog.open(AddNewGroupComponent, {
        data: {
          userId: this.userId,
          tenantId: this.data?.tenantId,
        },
        width: '420px'
      });
  
      dialogRef.afterClosed().subscribe(groupId => {
        if(groupId) {
          this.populateGroupDropdown(groupId);
        }
      });
    }
  
    populateGroupDropdown(groupId?: number){
      this.groupService.getGroups(this.data?.tenantId).pipe(
          catchError(error =>{
            console.error();
            return throwError(()=> error);
          })
      ).subscribe((result) =>{
        this.groups = result;
        if(this.groups.length > 0) {
          this.groups = this.groups.filter(g => !g.isGrid);
        }
        if(groupId) {
          let group = this.groups.find(g => g.id === groupId);
          this.softTissueSampleForm.controls.pinSampleGroup.setValue(group);
        }
        this.setInitialGroupList();
      })
    }
  
  
      saveSample() {
        this.nav.toggleLoading(true);

          let sampleObj = {
            pinId: this.pinId,
            linkedGroup: this.softTissueSampleForm.get('pinSampleGroup').value,
            name: this.softTissueSampleForm.get('sampleName').value,
            plantPart: this.plantPart,
            pinCropGrowthStageLinkId: this.softTissueSampleForm.get('growthStage').value,
            note: this.softTissueSampleForm.get('note').value
          };

          this.pinDetailsService.setSoftTissueSampleDetails(sampleObj);
  
          this.sampleService.postSoftTissueSample(sampleObj?.pinId, sampleObj?.linkedGroup?.id, sampleObj?.name, sampleObj?.plantPart?.id, sampleObj?.pinCropGrowthStageLinkId, sampleObj?.note, this.selectedDefinitionId).pipe(
              catchError(error => {
                console.error(error);
                this.nav.toggleLoading(false);
                return throwError(() => error);
              })
          ).subscribe(() => {
            this.softTissueSampleDialog.close();
          });
      }
  
      deleteSample(){
        this.nav.toggleLoading(true);
    
        this.sampleService.deleteSampleById(this.sampleId).pipe(
            catchError(error => {
              console.error(error);
              this.nav.toggleLoading(false);
              return throwError(() => error);
            })
        ).subscribe(() => {
          this.softTissueSampleDialog.close();
          this.nav.toggleLoading(false);
        });
      }

      updateSample(){

        this.nav.toggleLoading(true);

        let sampleObj = {
          pinId: this.pinId,
          sampleId: this.sampleId,
          linkedGroup: this.softTissueSampleForm.get('pinSampleGroup').value,
          name: this.softTissueSampleForm.get('sampleName').value,
          plantPart: this.softTissueSampleForm.get('plantPart').value,
          pinCropGrowthStageLinkId: this.softTissueSampleForm.get('growthStage').value,
          note: this.softTissueSampleForm.get('note').value,
          isCompleted: this.isCompleted
        };
             
        
        this.sampleService.updateSoftTissueSample(sampleObj?.pinId, sampleObj?.sampleId, sampleObj?.linkedGroup?.id, sampleObj?.name, sampleObj?.plantPart?.id, sampleObj?.pinCropGrowthStageLinkId, sampleObj?.note, sampleObj?.isCompleted).pipe(
            catchError(error => {
              console.error(error);
              this.nav.toggleLoading(false);
              return throwError(() => error);
            })
        ).subscribe(() => {
          if (this.selectedDefinitionId) {
            this.sampleService.updateSampleLink(this.sampleId, this.selectedDefinitionId).subscribe(() => {
              this.softTissueSampleDialog.close();
            });
          } else {
            this.softTissueSampleDialog.close();
          }
        });

      }

    cancel(){
      this.softTissueSampleDialog.close();
    }


      setPreviousSelection(){

        if(this.pinDetailsService.getSoftTissueSampleDetails() && !this.isEditSampleMode){
          
          let previousSelectedSoftTissueDetail = this.pinDetailsService.getSoftTissueSampleDetails();
          
          this.softTissueSampleForm.controls.sampleName.setValue(previousSelectedSoftTissueDetail?.name);
          this.softTissueSampleForm.controls.growthStage.setValue(previousSelectedSoftTissueDetail?.pinCropGrowthStageLinkId);
          this.softTissueSampleForm.controls.note.setValue(previousSelectedSoftTissueDetail?.note);
  

          setTimeout(()=>{
            if(previousSelectedSoftTissueDetail?.plantPart){
              for(let plantPart of this.plantPartsList){
                if(plantPart.id === previousSelectedSoftTissueDetail?.plantPart?.id){
                  this.plantPart = plantPart;
                  break;
                }
              }
              this.softTissueSampleForm.controls.plantPart.setValue(this.plantPart);
            }

            if(previousSelectedSoftTissueDetail?.linkedGroup){

              for(let group of this.groups){
                if(group.id === previousSelectedSoftTissueDetail?.linkedGroup?.id){
                  this.group = group;
                  break;
                }
              }
            }
        this.softTissueSampleForm.controls.pinSampleGroup.setValue(this.group);
          this.nav.toggleLoading(false);
          },1000)
        } else {
          this.nav.toggleLoading(false);
        }
      }

    ngOnDestroy() {
      this._onGroupDestroy.next();
      this._onGroupDestroy.complete();
    }

    loadDefinitions() {
      this.sampleService.getDefinitionsForPin(this.pinId).subscribe((defs) => {
        this.definitions = defs || [];
        if (this.data?.seasonFieldDetailId) {
          this.selectedDefinitionId = this.data.seasonFieldDetailId;
          this.isOrphanedLink = !this.definitions.some(d => d.id === this.selectedDefinitionId);
        } else if (this.definitions.length === 1) {
          this.selectedDefinitionId = this.definitions[0].id;
        }
      });
    }

}
